export enum MessagesLocale {
  RESEND = 'Resend Message',
  RESEND_SUBTITLE = 'This message was previously sent on ',
  SEND = 'Send Message',
  SENT = 'Message sent successfully',
  EDIT = 'Edit Message',
  DELETE = 'Delete Message',
  ADD_ATTACHMENTS = 'Add Attachments',
  CREATED = 'Message created successfully',
  UPDATE_SENDER = 'Click to change the sender',
  UPDATE_RECIPIENT = 'Click to make changes this recipient',
  SCHEDULE_SEND = 'Click to schedule this message for a later date',
}
